// extracted by mini-css-extract-plugin
module.exports = {"input":"DateInput_input__1gxk7","no-margin":"DateInput_no-margin__2MGnV","icon":"DateInput_icon__mev2v","datepicker":"DateInput_datepicker__1MgTq"};